import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchTables(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                const params = new URLSearchParams();

                if (queryParams.q) {
                    params.append('search', queryParams.q);
                } else {
                    params.append('search', '');
                }
                params.append('page', queryParams.page || 1);
                params.append('perPage', queryParams.perPage || 10);

                axios
                    .get('/api/v1/DTC/table/search', { params }) 
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        inactivateTable(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete('/api/v1/DTC/table', { params: { id } })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addTable(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/v1/DTC/table', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        linkModel(ctx, { dtcTableId, assetModelId, assetModelIds }) {
            const ids = assetModelIds || (assetModelId ? [assetModelId] : [])
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/v1/DTC/table/applications', { dtcTableId, assetModelIds: ids })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchTableDetail(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/DTC/table?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateTable(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/v1/DTC/table', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        unlinkModel(ctx, { dtcTableId, assetModelId }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/v1/DTC/table/applications?dtcTableId=${dtcTableId}&assetModelId=${assetModelId}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchItems(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                const params = new URLSearchParams();
                params.append('dtcTableId', queryParams.dtcTableId);
                if (queryParams.spn) params.append('spn', queryParams.spn);
                if (queryParams.fmi) params.append('fmi', queryParams.fmi);
                if (queryParams.description) params.append('description', queryParams.description);
                params.append('page', queryParams.page || 1);
                params.append('perPage', queryParams.perPage || 10);
                
                axios
                    .get('/api/v1/DTC/table/items/search', { params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addItems(ctx, itemsData) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/v1/DTC/table/items', itemsData) // array expected
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateItem(ctx, itemData) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/v1/DTC/table/items', itemData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteItems(ctx, { dtcTableId, ids }) {
            return new Promise((resolve, reject) => {
                const params = new URLSearchParams()
                if (dtcTableId) {
                    params.append('DTCTableId', dtcTableId)
                }
                if (Array.isArray(ids)) {
                    ids.forEach(id => params.append('Ids', id))
                }
                axios
                    .delete('/api/v1/DTC/table/items', { params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        importItems(ctx, { dtcTableId, file }) {
            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('file', file);
                
                axios
                    .post(`/api/v1/DTC/table/items/import?dtcTableId=${dtcTableId}`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchCoverage(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                const params = new URLSearchParams();
                if (queryParams.q) params.append('search', queryParams.q);
                if (queryParams.manufacturerId) params.append('manufacturerId', queryParams.manufacturerId);
                if (queryParams.hasTable !== null && queryParams.hasTable !== undefined && queryParams.hasTable !== 'all') {
                    params.append('hasTable', queryParams.hasTable);
                }
                params.append('page', queryParams.page || 1);
                params.append('perPage', queryParams.perPage || 10);
                
                axios
                    .get('/api/v1/DTC/coverage', { params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }
    }
}
